export const assetAttributeTypeConstants = [
  { name: "RAM", value: 1 },
  { name: "HDD", value: 2 },
  { name: "SSD", value: 3 },
  { name: "ROM", value: 4 },
  { name: "GPU", value: 6 },
  { name: "Other", value: 5 },
];
